import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import workspace from './workspace/reducer';
import auth from './auth/reducer';
import oauth from './oauth/reducer';
import versionAuth from './versionAuth/reducer';
import promotion from './promotion/reducer';

const reducers = combineReducers({
	auth,
	oauth,
	workspace,
	menu,
	settings,
	versionAuth,
	promotion,
});

export default reducers;
